import { Types } from '../actions/types'
import initialState from '../store/initial.state'

export const alertReducer = (state = initialState.alertReducer, action) => {
  switch (action.type) {
    case Types.ADD_USER_ALERT: {
      let addUserAlert = action.payload
      return {
        ...state,
        alert: {
          addUserAlert: addUserAlert,
        },
      }
    }
    case Types.DELETE_USER_ALERT: {
      let deleteUserAlert = action.payload
      return {
        ...state,
        alert: {
          deleteUserAlert: deleteUserAlert,
        },
      }
    }
    case Types.ADD_SUPPLIER_ALERT: {
      let addSupplierAlert = action.payload
      return {
        ...state,
        alert: {
          addSupplierAlert: addSupplierAlert,
        },
      }
    }
    case Types.UPDATE_SUPPLIER_ALERT: {
      let updateSupplierAlert = action.payload
      return {
        ...state,
        alert: {
          updateSupplierAlert: updateSupplierAlert,
        },
      }
    }
    case Types.ADD_PRODUCT_ALERT: {
      let addProductAlert = action.payload
      return {
        ...state,
        alert: {
          addProductAlert: addProductAlert,
        },
      }
    }
    case Types.UPDATE_PRODUCT_ALERT: {
      let updateProductAlert = action.payload
      return {
        ...state,
        alert: {
          updateProductAlert: updateProductAlert,
        },
      }
    }
    case Types.UPDATE_INVENTORY_ITEM_ALERT: {
      let updateInventoryItemAlert = action.payload
      return {
        ...state,
        alert: {
          updateInventoryItemAlert: updateInventoryItemAlert,
        },
      }
    }
    default:
      return state
  }
}
